import { Component, Injector, Input, OnInit } from '@angular/core';
import { IManagableObject } from "../../IManagableObject";
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { DriversService } from "../../../../services/drivers.service";
import { KeysService } from "../../../../services/keys.service";
import { ContainersService } from "../../../../services/containers.service";
import { DriversViewModel } from "../models/DriversViewModel";
import { ContainerViewModel } from "../../ContainerViewModel";

@Component({
  selector: 'app-drivers-dialog-base',
  templateUrl: './drivers-dialog-base.component.html',
  styleUrls: ['./drivers-dialog-base.component.css'],
  standalone: false
})
export class DriversDialogBaseComponent extends DialogBaseComponent<DriversViewModel> implements OnInit {

  @Input()
  public groups: IManagableObject[] = [];

  @Input()
  public keys: IManagableObject[] = [];
  public containers: ContainerViewModel[] = [];
  protected keysService: KeysService;
  protected containersService: ContainersService;
  protected service: DriversService;
  selectedContainers: ContainerViewModel[];

  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(DriversService);
    this.keysService = injector.get(KeysService);
    this.containersService = injector.get(ContainersService);
  }


  ngOnInit() {
    super.ngOnInit();
    this.keysService.GetKeys().subscribe(keys => {
      this.keys = keys;
    });
    this.service.GetGroups().subscribe(groups => {
      this.groups = groups;
    });

    this.loadContainers();
  }

  show(id: number) {
    this.model = new DriversViewModel();
    this.service.GetAllDrivers()
      .subscribe(drivers => {
        this.model = drivers.find(d => d.Id == id);
        if (this.model == undefined) return;
        this.open(this.model);
      })
  }


  open(model: DriversViewModel, type: { new(): DriversViewModel } = undefined) {
    super.open(model, type);
    this.loadContainers();
    if (model.Id > 0) {
      /*this.service.GetDriverGroup(model.Id).subscribe(groups => {
        model.Groups = groups.map(g => g.Id);
      });*/
      /*this.service.GetDriverKeys(model.Id).subscribe(keys => {
        model.Keys = keys.map(g => g.Id);
      });*/
    }
  }

  public get isEditMode(): boolean {
    return (this.model?.Id ?? 0) > 0;
  }

  public getSelectedContainerName(): string {
    const containerId = this.model?.ContainerId;
    if (!containerId) return "";
    return this.containers.find(x => x.Id === containerId)?.Name ?? "";
  }

  private ensureContainerSelected() {
    if (!this.model) return;

    if (this.model.ContainerId && this.containers.some(x => x.Id === this.model.ContainerId))
      return;
    if (!this.isEditMode)
      this.model.ContainerId = this.containers[0]?.Id;
  }

  private loadContainers() {
    const companyId = this.usersService.getCurrentUser()?.CompanyId;
    if (!companyId) {
      this.containers = [];
      if (this.model && !this.isEditMode)
        this.model.ContainerId = undefined;
      return;
    }

    this.containersService.GetContainers().subscribe(containers => {
      this.containers = [...(containers ?? [])]
        .sort((a, b) => (a.Name ?? "").localeCompare(b.Name ?? ""));
      this.selectedContainers = this.containers;

      this.ensureContainerSelected();
    });
  }


}
